import React, { useState, useContext, useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';

import {deslogar} from '../../services/FiltrosApi/LoginToken';

import {Context} from '../../services/contexts/StateContext';

import * as S from './styles';
import iconeUser from '../../midia/user_padrao.png';

import Logo from '../../midia/maisAP.svg';
import Notif from '../../midia/bell.svg';

import regulamentoPdf from '../../midia/arquivosPDF/regulamento_Mais apoio_2025.pdf';

//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

function Header(props) {
  const {state, dispatch} = useContext(Context);  
  const [pendente, setPendente] = useState('');
  const [sair, setSair] = useState(false);
  const [menuAberto, setMenuAberto] = useState(false);
  const {playmodal, displayModal, parametroInit} =  state.parametros;
  const {logado} =  state.cliente;
  const history = useHistory();


//--------------------------------------

const SetParametroInit = (key, value) => {
        dispatch({
            type: 'SET_parametroInit',
            payload: { ...parametroInit, [key]: value }
        });
    };
// --------------------------------------

  // async function VerifyPendte(){
  //   await api.get(`/evento/pendente`) // Buscar pendente por Regional
  //   .then(resposta => {
  //     if(resposta.data.length===0){
  //       setPendente(false)
  //     }else{
  //     setPendente(resposta.data.length);
  //   }})
  // }


  // useEffect(() => {
  //   VerifyPendte();

  // },[])

  //-----------------------------
  function iconConta(){
    sair===false ? setSair(true) : setSair(false);
  }
  // ---------------------------
  function toggleMenu(){
    setMenuAberto(!menuAberto);
  }
  // ---------------------------
  function irParaLogin(){
    SetParametroInit('playLogin', true);
    setMenuAberto(false);
    history.push('/login');
  }
  // ---------------------------
  function irParaCotacao(){
    history.push('/cotacao');
    setMenuAberto(false);
  }
  // ---------------------------
  useEffect(() => {
    setSair(false);
    setMenuAberto(false);
  }, [displayModal])
  //-----------------------------
  function Logout(){
    deslogar();
    window.location.reload();
  }
  //-----------------------------
  function MeusDados(){
    dispatch({
      type: 'set_usuario',
      payload: {
        ...state.cliente.usuario,
        id_Usuario: logado.idLogado,
        cpf: logado.cpf,
        nome: logado.nome,
        email: logado.email,
        senha: '',
      }
    });
    dispatch({
      type: 'SET_parametroInit',
      payload: {
        ...parametroInit,
        detalhesLista: true,
        detalhesModal: true,
        editModal: false,
        disabled: true,
      }
    });
    dispatch({
      type: 'SET_Display',
      payload: {
        ...displayModal,
        contaDisplay: true,
        usuarioDisplay: false,
        clienteDisplay: false,
        veiculosDisplay: false,
        eventoDisplay: false,
        colaboradorDisplay: false,
        CobrancaDisplay: false,
      }
    });
    dispatch({
      type: 'SET_PLAYMODAL',
      payload: {...playmodal, playModalUsuario: true}
    });
    setSair(false);
    history.push('/');
  }
  //-----------------------------
  function NewSenha(){
    dispatch({
      type: 'SET_PLAYMODAL',
      payload:{...playmodal, playModalUsuario:true}
  });
  };
  
  //-----------------------------
  const Download = () => {
    // Se o arquivo foi importado, você pode usar o URL criado pelo webpack
    const link = document.createElement('a');
    link.href = regulamentoPdf;
    link.download = 'regulamento2025.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

//###################################
  return (

    <S.Header>

        {props.playLogo?
        <S.Icone>
          <Link to='/'><img src={Logo}/></Link>
        </S.Icone>
        :
        <button 
        style={{display:"flex", fontSize:"clamp(10px, 1vw, 12px)", minWidth:"130px", justifyContent:"center"}} 
        onClick={Download}
        >
          REGULAMENTO DO <br/>ASSOCIADO
        </button>
        }

      <S.Header2>        
        {logado.conectado ? 
        <>

        {pendente &&    
        <button onClick={props.clickNotf} id='notification'>
          <img src={Notif} alt='Notificação'/>
            <span>{pendente}</span> 
        </button>
        }

        <S.Conta>
          <div>
              <img src={iconeUser} onClick={iconConta}/>
                <span>{logado.nome}</span>
          </div>
          
          {sair &&
          <S.iconConta>
            <button type='button' onClick={MeusDados}>
              <span>Usuário</span>
            </button>
            {/* <button type='button' onClick={NewSenha}>
              <span>Senha</span>
            </button> */}
            <button type='button' onClick={Logout} id='sair'>
              <span>Sair</span>
            </button>
          </S.iconConta>
          }
        </S.Conta>
        </>

        :

        <S.MenuContainer>
          <span onClick={toggleMenu} style={{color:"white", marginRight:"20px", cursor:"pointer"}}>Menu</span>
          
          {menuAberto &&
          <S.MenuDropdown>
            <button type='button' onClick={irParaLogin}>
              <span>Login</span>
            </button>
            <button type='button' onClick={irParaCotacao}>
              <span>Cotação</span>
            </button>
          </S.MenuDropdown>
          }
        </S.MenuContainer>
        }
      </S.Header2>
    </S.Header>
)}
export default Header;